// extracted by mini-css-extract-plugin
export default {"roadmap":"style_roadmap__reMAD","content":"style_content__PM9rk","image":"style_image__jyrUs"};